module.exports = __webpack_public_path__ + "static/media/satellite.0140b01f.svg";